import axios from 'axios'
import i18n from '../i18n'

const apiBase = process.env.VUE_APP_API_BASE || '/api'

const client = axios.create({
  baseURL: apiBase,
  timeout: 8000
})

client.interceptors.response.use(response => {
  const payload = response.data
  if (!payload || payload.success !== true) {
    return Promise.reject(new Error(payload && payload.message ? payload.message : '接口请求失败'))
  }
  return payload.data
})

export function getBanners(position) {
  return client.get(`/public/banners/${position}`, { params: { lang: i18n.locale } })
}

export function getCategories(module) {
  return client.get(`/public/categories/${module}`, { params: { lang: i18n.locale } })
}

export function getContents(module, params = {}) {
  return client.get(`/public/contents/${module}`, { params: { ...params, lang: i18n.locale } })
}

export function getContent(module, id) {
  return client.get(`/public/contents/${module}/${id}`, { params: { lang: i18n.locale } })
}

export function resolveAssetUrl(url, fallback = '') {
  if (!url) return fallback
  if (/^(https?:|data:|blob:)/i.test(url)) return url
  if (!url.startsWith('/uploads/')) return url
  if (apiBase.startsWith('http')) return `${new URL(apiBase).origin}${url}`
  return url
}
